/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
export * from './common_appname1.js'
export * from './common_loading.js'
export * from './common_saving.js'
export * from './common_sending.js'
export * from './common_cancel.js'
export * from './common_close.js'
export * from './common_save.js'
export * from './common_delete.js'
export * from './common_deleting.js'
export * from './common_remove.js'
export * from './common_edit.js'
export * from './common_search.js'
export * from './common_noresults1.js'
export * from './common_user.js'
export * from './common_email.js'
export * from './common_unknown.js'
export * from './common_never.js'
export * from './common_justnow1.js'
export * from './common_name.js'
export * from './common_backtodashboard2.js'
export * from './common_accessdenied1.js'
export * from './common_status.js'
export * from './common_creating.js'
export * from './common_actions.js'
export * from './common_phonenumber1.js'
export * from './common_notes.js'
export * from './common_savechanges1.js'
export * from './common_viewdetails1.js'
export * from './common_previous.js'
export * from './common_next.js'
export * from './common_morepages1.js'
export * from './common_more.js'
export * from './common_progress.js'
export * from './common_toggletheme1.js'
export * from './common_togglesidebar1.js'
export * from './common_previousslide1.js'
export * from './common_nextslide1.js'
export * from './common_gotopreviouspage3.js'
export * from './common_gotonextpage3.js'
export * from './common_pagination.js'
export * from './common_searchcountry1.js'
export * from './common_nocountryfound2.js'
export * from './common_view.js'
export * from './common_comingsoon1.js'
export * from './common_contactus1.js'
export * from './common_searchproducts1.js'
export * from './account_delete_confirm_cancel.js'
export * from './account_delete_confirm_delete.js'
export * from './account_delete_deleting.js'
export * from './account_notifications_active.js'
export * from './account_notifications_brands_label.js'
export * from './account_notifications_delete.js'
export * from './account_notifications_delete_confirm_description.js'
export * from './account_notifications_delete_confirm_title.js'
export * from './account_notifications_edit.js'
export * from './account_notifications_empty_description.js'
export * from './account_notifications_empty_title.js'
export * from './account_notifications_expired.js'
export * from './account_notifications_expires.js'
export * from './account_notifications_go_to_item.js'
export * from './account_notifications_no_expiry.js'
export * from './account_notifications_paused.js'
export * from './account_notifications_scope_item.js'
export * from './account_notifications_scope_tags.js'
export * from './account_notifications_tags_label.js'
export * from './account_notifications_threshold.js'
export * from './account_notifications_toast_activated.js'
export * from './account_notifications_toast_delete_error.js'
export * from './account_notifications_toast_deleted.js'
export * from './account_notifications_toast_paused.js'
export * from './account_notifications_toast_toggle_error.js'
export * from './account_reviews_contentlabel1.js'
export * from './account_reviews_contentplaceholder1.js'
export * from './account_reviews_delete.js'
export * from './account_reviews_delete_confirm_description.js'
export * from './account_reviews_delete_confirm_title.js'
export * from './account_reviews_edited_on.js'
export * from './account_reviews_edit.js'
export * from './account_reviews_editdescription1.js'
export * from './account_reviews_edittitle1.js'
export * from './account_reviews_empty_description.js'
export * from './account_reviews_empty_title.js'
export * from './account_reviews_go_to_item.js'
export * from './account_reviews_rating.js'
export * from './account_reviews_ratinglabel1.js'
export * from './account_reviews_titlelabel1.js'
export * from './account_reviews_titleplaceholder1.js'
export * from './account_reviews_toast_delete_error.js'
export * from './account_reviews_toast_deleted.js'
export * from './account_reviews_toast_update_error.js'
export * from './account_reviews_toast_updated.js'
export * from './account_reviews_written_on.js'
export * from './account_tabs_notifications.js'
export * from './account_tabs_profile.js'
export * from './account_tabs_reviews.js'
export * from './account_title.js'
export * from './auth_login_title.js'
export * from './auth_login_descriptionotp1.js'
export * from './auth_login_emaillabel1.js'
export * from './auth_login_emailplaceholder1.js'
export * from './auth_login_sendotp1.js'
export * from './auth_login_sendingotp1.js'
export * from './auth_login_continuewithgoogle2.js'
export * from './auth_login_googleloading1.js'
export * from './auth_otp_title.js'
export * from './auth_otp_description.js'
export * from './auth_otp_label.js'
export * from './auth_otp_verifying.js'
export * from './auth_otp_verifybutton1.js'
export * from './auth_otp_changeemail1.js'
export * from './auth_signup_prompt.js'
export * from './auth_signup_cta.js'
export * from './auth_signup_title.js'
export * from './auth_signup_descriptionpasswordless1.js'
export * from './auth_signup_firstname1.js'
export * from './auth_signup_lastname1.js'
export * from './auth_signup_sendotp1.js'
export * from './auth_signup_otp_title.js'
export * from './auth_signup_otp_description.js'
export * from './auth_signup_otp_submit.js'
export * from './auth_signup_submit.js'
export * from './auth_signup_haveaccount1.js'
export * from './auth_signup_signin1.js'
export * from './auth_signup_errors_failed.js'
export * from './auth_signup_errors_resendfailed1.js'
export * from './auth_modal_title.js'
export * from './auth_modal_description.js'
export * from './auth_verify_verifying.js'
export * from './auth_verify_success.js'
export * from './auth_verify_failed.js'
export * from './auth_verify_failedmessage1.js'
export * from './auth_logout.js'
export * from './auth_menu_settings.js'
export * from './hero_headline.js'
export * from './hero_description.js'
export * from './hero_notifications_title.js'
export * from './hero_notifications_description.js'
export * from './hero_reviews_title.js'
export * from './hero_reviews_description.js'
export * from './auth_errors_failedtosendotp3.js'
export * from './auth_errors_failedtoverifyotp3.js'
export * from './auth_errors_failedtosigninwithgoogle5.js'
export * from './nav_dashboard.js'
export * from './nav_posts.js'
export * from './nav_helpsupport1.js'
export * from './nav_account.js'
export * from './nav_billing.js'
export * from './nav_notifications.js'
export * from './nav_profile.js'
export * from './nav_backinstock2.js'
export * from './nav_extension.js'
export * from './nav_faq.js'
export * from './nav_lowestprices1.js'
export * from './nav_newitems1.js'
export * from './nav_pricedrops1.js'
export * from './landing_headline.js'
export * from './landing_subheadline.js'
export * from './landing_cta.js'
export * from './dashboard_title.js'
export * from './dashboard_stats_totalrevenue1.js'
export * from './dashboard_stats_subscriptions.js'
export * from './dashboard_stats_sales.js'
export * from './dashboard_stats_activenow1.js'
export * from './dashboard_stats_fromlastmonth2.js'
export * from './dashboard_stats_sincelasthour2.js'
export * from './dashboard_recentsales_title1.js'
export * from './dashboard_recentsales_description1.js'
export * from './dashboard_recentsales_customer1.js'
export * from './dashboard_recentsales_amount1.js'
export * from './dashboard_recentsales_date1.js'
export * from './dashboard_recentsales_paid1.js'
export * from './dashboard_recentactivity_title1.js'
export * from './dashboard_recentactivity_description1.js'
export * from './dashboard_recentactivity_newuserregistered3.js'
export * from './dashboard_recentactivity_projectapproved2.js'
export * from './dashboard_recentactivity_serveralertresolved3.js'
export * from './dashboard_recentactivity_subscriptionrenewed2.js'
export * from './dashboard_overview_title.js'
export * from './dashboard_overview_description.js'
export * from './dashboard_overview_desktop.js'
export * from './dashboard_overview_mobile.js'
export * from './posts_title.js'
export * from './posts_create.js'
export * from './posts_edit.js'
export * from './posts_delete.js'
export * from './posts_deleteconfirm1.js'
export * from './posts_titlelabel1.js'
export * from './posts_titleplaceholder1.js'
export * from './posts_contentlabel1.js'
export * from './posts_contentplaceholder1.js'
export * from './posts_publishedlabel1.js'
export * from './posts_noposts1.js'
export * from './posts_success_created.js'
export * from './posts_success_updated.js'
export * from './posts_success_deleted.js'
export * from './posts_errors_failedtoload2.js'
export * from './posts_errors_failedtocreate2.js'
export * from './posts_errors_failedtoupdate2.js'
export * from './posts_errors_failedtodelete2.js'
export * from './command_placeholder.js'
export * from './command_suggestions.js'
export * from './command_navigation.js'
export * from './command_calendar.js'
export * from './command_searchemoji1.js'
export * from './command_calculator.js'
export * from './command_help.js'
export * from './notfound_title1.js'
export * from './notfound_code1.js'
export * from './notfound_description1.js'
export * from './itemnotfound_title2.js'
export * from './itemnotfound_description2.js'
export * from './itemnotfound_searchinvite3.js'
export * from './itemnotfound_searchbutton3.js'
export * from './header_buildingapp1.js'
export * from './header_datafetching1.js'
export * from './time_minutesago1.js'
export * from './time_hoursago1.js'
export * from './time_daysago1.js'
export * from './timezone_utc3.js'
export * from './timezone_america_newyork3.js'
export * from './timezone_america_chicago2.js'
export * from './timezone_america_denver2.js'
export * from './timezone_america_losangeles3.js'
export * from './timezone_europe_london2.js'
export * from './timezone_europe_paris2.js'
export * from './timezone_europe_berlin2.js'
export * from './timezone_asia_jerusalem2.js'
export * from './timezone_asia_tokyo2.js'
export * from './timezone_asia_shanghai2.js'
export * from './timezone_australia_sydney2.js'
export * from './currency_usd3.js'
export * from './currency_eur3.js'
export * from './currency_gbp3.js'
export * from './currency_ils3.js'
export * from './currency_jpy3.js'
export * from './currency_cad3.js'
export * from './currency_aud3.js'
export * from './currency_chf3.js'
export * from './locale_enus2.js'
export * from './locale_heil2.js'
export * from './month_january.js'
export * from './month_february.js'
export * from './month_march.js'
export * from './month_april.js'
export * from './month_may.js'
export * from './month_june.js'
export * from './month_july.js'
export * from './month_august.js'
export * from './month_september.js'
export * from './month_october.js'
export * from './month_november.js'
export * from './month_december.js'
export * from './server_errors_resourcenotfound2.js'
export * from './server_errors_unexpectederror1.js'
export * from './server_errors_authrequired1.js'
export * from './server_errors_noviewpermission2.js'
export * from './server_errors_noeditpermission2.js'
export * from './server_errors_nopermission1.js'
export * from './server_errors_nofieldstoupdate3.js'
export * from './server_errors_ratelimited1.js'
export * from './profile_title.js'
export * from './profile_personal_title.js'
export * from './profile_personal_description.js'
export * from './profile_nameplaceholder1.js'
export * from './profile_emailnote1.js'
export * from './profile_phoneverified_yes1.js'
export * from './profile_phoneverified_no1.js'
export * from './profile_phoneplaceholder1.js'
export * from './profile_language_description.js'
export * from './profile_locale.js'
export * from './profile_locale_selectplaceholder1.js'
export * from './profile_errors_failedtoload2.js'
export * from './profile_errors_failedtosave2.js'
export * from './profile_errors_invalidphone1.js'
export * from './profile_errors_namerequired1.js'
export * from './profile_success_saved.js'
export * from './help_title.js'
export * from './help_gettingstarted_title1.js'
export * from './help_gettingstarted_description1.js'
export * from './help_gettingstarted_item11.js'
export * from './help_gettingstarted_item21.js'
export * from './help_gettingstarted_item31.js'
export * from './help_gettingstarted_item41.js'
export * from './help_contact_title.js'
export * from './help_contact_description.js'
export * from './help_contact_email.js'
export * from './help_contact_emailaddress1.js'
export * from './help_shortcuts_title.js'
export * from './help_shortcuts_description.js'
export * from './help_shortcuts_commandmenu1.js'
export * from './help_shortcuts_search.js'
export * from './contact_title.js'
export * from './contact_subtitle.js'
export * from './contact_contactmethods1.js'
export * from './contact_emaillabel1.js'
export * from './contact_faqheading1.js'
export * from './contact_faqsuggestion1.js'
export * from './contact_faqlink1.js'
export * from './contact_sendmessage1.js'
export * from './contact_form_fullname1.js'
export * from './contact_form_fullnameplaceholder2.js'
export * from './contact_form_emaillabel1.js'
export * from './contact_form_message.js'
export * from './contact_form_messageplaceholder1.js'
export * from './contact_form_submit.js'
export * from './contact_form_submitting.js'
export * from './contact_validation_namemin1.js'
export * from './contact_validation_emailinvalid1.js'
export * from './contact_validation_messagemin1.js'
export * from './contact_turnstilefailed1.js'
export * from './contact_turnstilerequired1.js'
export * from './contact_submiterror1.js'
export * from './contact_success_title.js'
export * from './contact_success_subtitle.js'
export * from './contact_success_whatnext1.js'
export * from './contact_success_responsetime1.js'
export * from './contact_success_backtohome2.js'
export * from './contact_success_sendanother1.js'
export * from './contact_success_urgentquestion1.js'
export * from './contact_success_checkfaq1.js'
export * from './faq_notfoundanswer2.js'
export * from './faq_contactprompt1.js'
export * from './footer_description.js'
export * from './footer_extension.js'
export * from './footer_termsofuse2.js'
export * from './footer_privacypolicy1.js'
export * from './footer_accessibility.js'
export * from './footer_faq.js'
export * from './footer_contact.js'
export * from './home_subtitle.js'
export * from './home_recentpricedrops2.js'
export * from './home_popularcategories1.js'
export * from './home_category_laptops.js'
export * from './home_category_phones.js'
export * from './home_category_tvs.js'
export * from './home_category_headphones.js'
export * from './home_category_cameras.js'
export * from './home_category_gaming.js'
export * from './home_category_monitors.js'
export * from './home_category_keyboards.js'
export * from './home_category_tablets.js'
export * from './home_category_smartwatches.js'
export * from './home_category_speakers.js'
export * from './home_category_toys.js'
export * from './home_category_home.js'
export * from './home_category_beauty.js'
export * from './home_category_coffee.js'
export * from './home_category_printers.js'
export * from './home_category_consoles.js'
export * from './home_category_fridges.js'
export * from './home_category_washers.js'
export * from './home_category_ac.js'
export * from './home_headline.js'
export * from './home_subtitle_stat.js'
export * from './home_trust_products.js'
export * from './home_trust_tracking.js'
export * from './home_trust_freealerts1.js'
export * from './home_trust_reviews.js'
export * from './home_seeall1.js'
export * from './home_morepricedrops2.js'
export * from './home_category_vacuums.js'
export * from './home_cta_title.js'
export * from './home_cta_subtitle.js'
export * from './home_cta_button.js'
export * from './logo_subtitle.js'
export * from './search_filter.js'
export * from './notfound_error1.js'
export * from './common_backtohome2.js'
export * from './error_title.js'
export * from './error_generic.js'
export * from './error_devinfo1.js'
export * from './error_retry.js'
export * from './verify_verifying.js'
export * from './verify_success.js'
export * from './verify_failed.js'
export * from './verify_pleasewait1.js'
export * from './verify_signedin1.js'
export * from './verify_backtologin2.js'
export * from './extension_herotitle1.js'
export * from './extension_herotitleaccent2.js'
export * from './extension_herosubtitle1.js'
export * from './extension_downloadtitle1.js'
export * from './extension_demotitle1.js'
export * from './extension_demosubtitle1.js'
export * from './extension_featurestitle1.js'
export * from './extension_featuressubtitle1.js'
export * from './extension_stepstitle1.js'
export * from './extension_stepssubtitle1.js'
export * from './extension_reviewstitle1.js'
export * from './extension_reviewssubtitle1.js'
export * from './extension_ctatitle1.js'
export * from './extension_ctasubtitle1.js'
export * from './extension_ctadownload1.js'
export * from './extension_slide1alt1.js'
export * from './extension_slide1title1.js'
export * from './extension_slide1description1.js'
export * from './extension_slide2alt1.js'
export * from './extension_slide2title1.js'
export * from './extension_slide2description1.js'
export * from './extension_slide3alt1.js'
export * from './extension_slide3title1.js'
export * from './extension_slide3description1.js'
export * from './extension_featurechartstitle2.js'
export * from './extension_featurechartsdescription2.js'
export * from './extension_featurehistorytitle2.js'
export * from './extension_featurehistorydescription2.js'
export * from './extension_featurestatstitle2.js'
export * from './extension_featurestatsdescription2.js'
export * from './extension_featureprivacytitle2.js'
export * from './extension_featureprivacydescription2.js'
export * from './extension_step1title1.js'
export * from './extension_step1description1.js'
export * from './extension_step2title1.js'
export * from './extension_step2description1.js'
export * from './extension_step3title1.js'
export * from './extension_step3description1.js'
export * from './notifications_bell_create.js'
export * from './notifications_bell_update.js'
export * from './notifications_bell_back_in_stock.js'
export * from './notifications_dialog_title.js'
export * from './notifications_dialog_description.js'
export * from './notifications_type_label.js'
export * from './notifications_type_price_drop.js'
export * from './notifications_type_back_in_stock.js'
export * from './notifications_type_any_change.js'
export * from './notifications_type_price_below_threshold.js'
export * from './notifications_type_lowest_price.js'
export * from './notifications_expiration_label.js'
export * from './notifications_expiration_1month.js'
export * from './notifications_expiration_3months.js'
export * from './notifications_expiration_6months.js'
export * from './notifications_expiration_1year.js'
export * from './notifications_expiration_hint.js'
export * from './notifications_expiration_until.js'
export * from './notifications_threshold_label.js'
export * from './notifications_threshold_current.js'
export * from './notifications_threshold_hint.js'
export * from './notifications_submit_create.js'
export * from './notifications_submit_update.js'
export * from './notifications_submit_saving.js'
export * from './notifications_delete_button.js'
export * from './notifications_delete_confirm_title.js'
export * from './notifications_delete_confirm_description.js'
export * from './notifications_delete_confirm_cancel.js'
export * from './notifications_delete_confirm_delete.js'
export * from './notifications_delete_deleting.js'
export * from './notifications_toast_created.js'
export * from './notifications_toast_updated.js'
export * from './notifications_toast_deleted.js'
export * from './notifications_toast_duplicate.js'
export * from './notifications_toast_error.js'
export * from './notifications_item_label.js'
export * from './notifications_item_number.js'
export * from './notifications_auth_title.js'
export * from './notifications_auth_description.js'
export * from './notifications_tags_dialog_description.js'
export * from './notifications_tags_reference_label.js'
export * from './notifications_tags_reference_hint.js'
export * from './notifications_tags_bell_create.js'
export * from './notifications_tags_bell_update.js'
export * from './notifications_tags_threshold_hint.js'
export * from './notifications_tags_threshold_label.js'
export * from './notifications_brand_pill_label.js'
export * from './notifications_tags_brand_dialog_description.js'
export * from './notifications_tags_brand_reference_hint.js'
export * from './auth_requireauth_notifications_title1.js'
export * from './auth_requireauth_notifications_description1.js'
export * from './auth_requireauth_reviews_title1.js'
export * from './auth_requireauth_reviews_description1.js'
export * from './auth_otp_resend.js'
export * from './auth_otp_resending.js'
export * from './auth_otp_resent.js'
export * from './profile_locale_default.js'
export * from './profile_locale_defaulthint1.js'
export * from './seo_sitename1.js'
export * from './seo_defaultdescription1.js'
export * from './seo_home_title.js'
export * from './seo_home_description.js'
export * from './seo_items_title.js'
export * from './seo_items_description.js'
export * from './seo_extension_title.js'
export * from './seo_extension_description.js'
export * from './seo_faq_title.js'
export * from './seo_faq_description.js'
export * from './seo_contact_title.js'
export * from './seo_contact_description.js'
export * from './seo_termsofuse_title2.js'
export * from './seo_termsofuse_description2.js'
export * from './seo_privacypolicy_title1.js'
export * from './seo_privacypolicy_description1.js'
export * from './seo_accessibility_title.js'
export * from './seo_accessibility_description.js'
export * from './seo_login_title.js'
export * from './seo_verify_title.js'
export * from './seo_profile_title.js'
export * from './seo_help_title.js'
export * from './seo_items_filtered_title.js'
export * from './ratelimit_title1.js'
export * from './ratelimit_description1.js'
export * from './ratelimit_protipbody3.js'
export * from './ratelimit_signin2.js'
export * from './ratelimit_tryagain2.js'
export * from './ratelimit_toasttitle2.js'
export * from './ratelimit_toastdescauth3.js'
export * from './ratelimit_toastdescguest3.js'
export * from './items_loaderror1.js'
export * from './account_tabs_alerts.js'
export * from './account_tabs_delivery.js'
export * from './account_alerts_explainer.js'
export * from './account_alerts_go_to_delivery.js'
export * from './account_delivery_title.js'
export * from './account_delivery_explainer.js'
export * from './account_delivery_go_to_alerts.js'
export * from './account_delivery_email_title.js'
export * from './account_delivery_email_identity_masked.js'
export * from './account_delivery_email_enabled_label.js'
export * from './account_delivery_email_verified.js'
export * from './account_delivery_telegram_title.js'
export * from './account_delivery_telegram_link_cta.js'
export * from './account_delivery_telegram_unlink_cta.js'
export * from './account_delivery_telegram_enabled_label.js'
export * from './account_delivery_telegram_not_linked.js'
export * from './account_delivery_whatsapp_title.js'
export * from './account_delivery_whatsapp_link_cta.js'
export * from './account_delivery_whatsapp_unlink_cta.js'
export * from './account_delivery_whatsapp_enabled_label.js'
export * from './account_delivery_whatsapp_link_dialog_title.js'
export * from './account_delivery_whatsapp_link_dialog_desc.js'
export * from './account_delivery_whatsapp_link_dialog_open_wa.js'
export * from './account_delivery_whatsapp_link_dialog_waiting.js'
export * from './account_delivery_whatsapp_linked_success.js'
export * from './account_delivery_whatsapp_not_linked.js'
export * from './account_delivery_linked.js'
export * from './account_delivery_not_linked.js'
export * from './account_delivery_enable_requires_linking.js'
export * from './account_delivery_channel_not_linked_error.js'
export * from './account_delivery_link_token_invalid.js'
export * from './account_delivery_link_jid_taken.js'
export * from './account_delivery_unlink_description_telegram.js'
export * from './account_delivery_unlink_description_whatsapp.js'
export * from './account_delivery_unlink_confirm_telegram.js'
export * from './account_delivery_unlink_confirm_whatsapp.js'
export * from './account_delivery_unlink_confirm_cta.js'
export * from './account_delivery_unlink_cancel_cta.js'
export * from './account_delivery_log_title.js'
export * from './account_delivery_log_empty.js'
export * from './account_delivery_log_status_sent.js'
export * from './account_delivery_log_status_failed.js'
export * from './account_delivery_log_status_skipped_disabled.js'
export * from './account_delivery_log_status_skipped_unlinked.js'
export * from './notifications_message_subject_price_drop.js'
export * from './notifications_message_subject_back_in_stock.js'
export * from './notifications_message_subject_any_change.js'
export * from './notifications_message_subject_lowest_price.js'
export * from './notifications_message_subject_threshold_hit.js'
export * from './notifications_message_body_was.js'
export * from './notifications_message_body_now.js'
export * from './notifications_message_body_delta.js'
export * from './notifications_message_body_view_item.js'
export * from './notifications_message_body_mean.js'
export * from './notifications_message_body_high.js'
export * from './notifications_message_body_low.js'
export * from './notifications_email_subject_price_drop.js'
export * from './notifications_email_footer_manage.js'
export * from './notifications_email_greeting.js'
export * from './notifications_email_preheader.js'
export * from './whatsapp_bot_link_help.js'
export * from './whatsapp_bot_link_success.js'
export * from './whatsapp_bot_link_failed.js'
export * from './whatsapp_bot_link_jid_taken.js'